export default "__VITE_ASSET__Bcxly81q__"